export default __webpack_public_path__ + "static/media/facebook.c99941fa.png";